import { getBearerTokenHeader } from '../../security/getBearerTokenHeader';
import { getCsrfTokenHeader } from '../../security/getCsrfTokenHeader';
import PermissionService from '../PermissionService';
export class GenericEntityService extends PermissionService {
    constructor(opts) {
        super(opts);
    }
    async findAllNoPaging(fetchOpts) {
        const pageOpts = {
            page: 0,
            size: 10
        };
        let list = [];
        try {
            while (true) {
                const response = await fetch(this.getPageUrl(pageOpts), {
                    method: 'GET',
                    headers: {
                        ...getBearerTokenHeader(this.keycloak)
                    },
                    ...fetchOpts
                });
                if (!response.ok) {
                    throw new Error(`HTTP error status: ${response.status}`);
                }
                const result = await response.json();
                list = list.concat(result.content);
                if (pageOpts.page < result.totalPages) {
                    pageOpts.page += 1;
                }
                else {
                    break;
                }
            }
            return list;
        }
        catch (error) {
            throw new Error(`Error while requesting all entities: ${error}`);
        }
    }
    async findAll(pageOpts, fetchOpts) {
        try {
            const response = await fetch(this.getPageUrl(pageOpts), {
                method: 'GET',
                headers: {
                    ...getBearerTokenHeader(this.keycloak)
                },
                ...fetchOpts
            });
            if (!response.ok) {
                throw new Error(`HTTP error status: ${response.status}`);
            }
            return await response.json();
        }
        catch (error) {
            throw new Error(`Error while requesting all entities: ${error}`);
        }
    }
    async findOne(id, fetchOpts) {
        try {
            const response = await fetch(`${this.basePath}/${id}`, {
                method: 'GET',
                headers: {
                    ...getBearerTokenHeader(this.keycloak)
                },
                ...fetchOpts
            });
            if (!response.ok) {
                throw new Error(`HTTP error status: ${response.status}`);
            }
            return await response.json();
        }
        catch (error) {
            throw new Error(`Error while requesting a single entity: ${error}`);
        }
    }
    async add(t, fetchOpts) {
        try {
            const response = await fetch(this.basePath, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...getCsrfTokenHeader(),
                    ...getBearerTokenHeader(this.keycloak)
                },
                body: JSON.stringify(t),
                ...fetchOpts
            });
            if (!response.ok) {
                throw new Error(`HTTP error status: ${response.status}`);
            }
            const json = await response.json();
            return json;
        }
        catch (error) {
            throw new Error(`Error while creating an entity: ${error}`);
        }
    }
    async update(t, fetchOpts) {
        try {
            const response = await fetch(`${this.basePath}/${t.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    ...getCsrfTokenHeader(),
                    ...getBearerTokenHeader(this.keycloak)
                },
                body: JSON.stringify(t),
                ...fetchOpts
            });
            if (!response.ok) {
                throw new Error(`HTTP error status: ${response.status}`);
            }
            return await response.json();
        }
        catch (error) {
            throw new Error(`Error while updating an entity: ${error}`);
        }
    }
    async updatePartial(t, fetchOpts) {
        try {
            const response = await fetch(`${this.basePath}/${t.id}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    ...getCsrfTokenHeader(),
                    ...getBearerTokenHeader(this.keycloak)
                },
                body: JSON.stringify(t),
                ...fetchOpts
            });
            if (!response.ok) {
                throw new Error(`HTTP error status: ${response.status}`);
            }
            return await response.json();
        }
        catch (error) {
            throw new Error(`Error while updating an entity partially: ${error}`);
        }
    }
    async delete(id, fetchOpts) {
        try {
            const response = await fetch(`${this.basePath}/${id}`, {
                method: 'DELETE',
                headers: {
                    ...getBearerTokenHeader(this.keycloak)
                },
                ...fetchOpts
            });
            if (!response.ok) {
                throw new Error(`HTTP error status: ${response.status}`);
            }
        }
        catch (error) {
            throw new Error(`Error while deleting an entity: ${error}`);
        }
    }
    getBasePath() {
        return this.basePath;
    }
}
export default GenericEntityService;
//# sourceMappingURL=index.js.map